import React from "react";
import { buildCmsUrl } from "../../../utils/imageHelper";
/*eslint-disable */

interface ManualesComponentProps {
  warranty_files: any;
}

declare const window: any;

const ManualesComponent: React.FC<ManualesComponentProps> = ({
  warranty_files,
}) => {
  console.log(warranty_files);
  
  return (
    <div className="manual-posventa-garantia-container">
      <div className="left-manual-posventa-garantia-container">
        {/* H2 - Título principal de la sección izquierda */}
        <h2 className="title">Manuales de garantía</h2>
      </div>
      
      <div className="rigth-manual-posventa-garantia-container">
        <div className="description">
          Queremos construir una relación a largo plazo contigo. Con nuestra
          garantía, te ofrecemos toda la tranquilidad que necesitas para
          disfrutar de tu Hyundai sin preocupaciones. Te invitamos a consultar
          los manuales de garantía en formato PDF para conocer las condiciones
          de tu cobertura.
        </div>
        
        <div className="description">
          ¡Más allá de las distancias recorridas, lo que realmente importa son
          las experiencias vividas!
        </div>
        
        {/* H3 - Subtítulo para la sección de manuales disponibles */}
        <h3 className="title">Manuales disponibles</h3>
        
        {warranty_files?.map((item: any, index: number) => (
          <div className="documentos" key={index}>
            <div className="description">
              {item?.name}
            </div>
            <a 
              href={buildCmsUrl(item?.warranty_file?.url)} 
              target="_blank" 
              rel="noopener noreferrer"
              className="btnn"
            >
              Ver documento
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ManualesComponent;